<template>
  <div class="body-right">
    <div class="title-body-right">
      <h1 class="title-page">{{ $t('category.title') }}</h1>

      <div class="group-btn">
        <el-button class="btn" type="primary" @click="handleOpenAddDialog()">
          {{ $t('category.addCategoryBtn') }}
        </el-button>

        <el-button
          class="btn btn-search-sp"
          type="primary"
          @click="toggleSearchBlock()"
        >
          {{ $t('common.toggleMenu') }}
        </el-button>
      </div>
    </div>

    <div class="search-wrap">
      <div class="search-form" :class="openSearchForm ? 'open' : 'hidden'">
        <el-form
          :inline="true"
          :model="search"
          class="form"
          @submit.native.prevent
          @keyup.enter.native="onSubmitSearch()"
        >
          <el-form-item>
            <el-input
              v-model="search.categoryName"
              :placeholder="$t('category.placeholderName')"
              class="search-input"
              maxlength="225"
            >
              <i
                slot="suffix"
                class="el-input__icon el-icon-circle-close el-input__clear"
                @click="search.categoryName = ''"
                v-if="search.categoryName"
              ></i>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              class="search-button"
              type="primary"
              @click="onSubmitSearch"
            >
              {{ $t('category.searchBtn') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row
        class="total-table"
        :class="openSearchForm ? 'total-table-absolute' : ''"
      >
        {{ $t('category.total') }}: {{ category.total }}
      </el-row>
    </div>

    <table-category
      :currentPage="category.currentPage"
      :dataColumn="category.data"
    />

    <div class="pagination">
      <base-pagination
        :totalPage="category.total"
        @changePage="changeCurrentPage"
        :currentPage="+$route.query.pageNumber"
      ></base-pagination>
    </div>

    <add-category-dialog
      :openAddDialog="openAddDialog"
      @handleCloseAddDialog="handleCloseAddDialog()"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { redirectRouter } from '@/helper';
import { LIMIT, PAGE } from '@/constants/common';
import pageRouter from '@/constants/pageRouter';

const BasePagination = () => import('@/components/BasePagination');
const AddCategoryDialog = () => import('./AddCategoryDialog');
const TableCategory = () => import('./TableListCategory');

export default {
  name: 'ListCategory',
  components: {
    BasePagination,
    AddCategoryDialog,
    TableCategory,
  },
  data() {
    return {
      openAddDialog: false,
      formLabelWidth: '120px',
      openSearchForm: true,
      search: {
        categoryName: undefined,
        pageNumber: PAGE,
        limit: LIMIT,
      },
    };
  },
  computed: {
    ...mapGetters('category', ['category']),
  },
  methods: {
    ...mapActions('category', ['getCategoryList']),
    handleOpenAddDialog() {
      this.openAddDialog = true;
    },
    handleCloseAddDialog() {
      this.openAddDialog = false;
    },
    onSubmitSearch() {
      this.search = {
        ...this.search,
        categoryName: this.search.categoryName
          ? this.search.categoryName.trim()
          : undefined,
        pageNumber: PAGE,
      };

      this.getCategoryList({
        name: this.search.categoryName,
        page: this.search.pageNumber,
        limit: LIMIT,
      });

      redirectRouter({
        path: pageRouter.CATEGORY,
        query: {
          categoryName: this.search.categoryName
            ? this.search.categoryName.trim()
            : undefined,
          pageNumber: this.search.pageNumber,
        },
      });
    },
    changeCurrentPage(e) {
      this.search = {
        ...this.$router.currentRoute.query,
        pageNumber: e.page,
        limit: LIMIT,
      };

      this.getCategoryList({
        limit: LIMIT,
        name: this.search.categoryName,
        page: this.search.pageNumber,
      });

      redirectRouter({
        path: pageRouter.CATEGORY,
        query: {
          ...this.$router.currentRoute.query,
          pageNumber: this.search.pageNumber || undefined,
        },
      });
    },
    toggleSearchBlock() {
      this.openSearchForm = !this.openSearchForm;
    },
  },
  created() {
    this.search = {
      ...this.search,
      ...this.$router.currentRoute.query,
    };
    this.getCategoryList({
      limit: LIMIT,
      name: this.search.categoryName,
      page: this.search.pageNumber,
    });
  },
};
</script>

<style lang="scss">
@import '@/styles/common.scss';
</style>
